const faqData = [
  {
    question: 'How do I renew my Pro account?',
    answer: [
      'LivDemy Pro is set to auto-renew every year, unless you choose to opt-out by reaching out to us.',
    ],
  },
  {
    question: `How do I buy this?`,
    answer: [
      `Click on the subscription plan of choice and complete the payment with Credit/Debit/Paypal or UPI`,
    ],
  },
  {
    question: `Why should I buy this?`,
    answer: [
      `If you're interested in multiple instruments, artists, or multiple genres of music, LivDemy Pro is an unfair advantage to your musical journey. If you wish to become a contributing member to LivDemy, or have a loved one deeply interested in the kind of music we teach here, you can buy or gift someone LivDemy Pro.`,
    ],
  },
  {
    question: `What do I get with LivDemy Pro?`,
    answer: [
      `You get unrestricted access to all our historic content as well as a deep discount on all classes. If you're on the Maestro plan, you also get access to 20 FREE Live Classes as well as deep discounts on our Courses and Group Classes.`,
    ],
  },
  {
    question: `How do I access Recordings?`,
    answer: [
      `If you're a Pro member, all our recordings are accessible to you. One caveat: Recordings are made available in about 2 months after the live class.`,
    ],
  },
  {
    question: `How do I get the additional discount?`,
    answer: [
      `If you're a Pro member, the discount is automatically applied for you on all class pages. Happy learning!`,
    ],
  },
]

export default faqData
